import * as AppConstants from '../constants/appConstants';

export let SETTINGS = {
    DEVELOPMENT_MODE: AppConstants.DEVELOPMENT_MODE
};

export let DATA_LOADED = {
    constant: AppConstants.INIT_STATE_DATA_LOADED,
    complete: false,
    localeStringConstant: "retrieving_label",
    message: ""
};

export let IMAGES_PRE_LOADED = {
    constant: AppConstants.INIT_STATE_IMAGES_PRE_LOADED,
    complete: false,
    localeStringConstant: "preloading_label",
    message: ""
};

export let TRACKING_READY = {
    constant: AppConstants.INIT_STATE_TRACKING_READY,
    complete: false,
    localeStringConstant: "initialising_tracking_label",
    message: ""
};

export let INIT_DATA = {
    initialised: false,
    checkInitialised: true,
    currentStateIndex: 0,
    currentState: AppConstants.INIT_STATE_DATA_LOADED,
    localeStringConstant: "creating_your_experience_label",
    mainMessage: "",
    resumed: false,
    lang_suspend_data_set: false,
    lang_preference_invoked: false,
    lang_preference_set: false,
    initialisedStates: [
        DATA_LOADED,
        IMAGES_PRE_LOADED,
        TRACKING_READY
    ]
};

export let TRACKING_DATA = {
    initialised: false,
    suspend_data: {},
    student_id: "",
    student_name: "",
    first_name: "",
    last_name: "",
    lesson_location: 0,
    lesson_status: "",
    score_raw: 0,
    score_min: 0,
    score_max: 100,
    location_history:[],
    last_lesson_location: 0,
    lrs :{}
};

export let TITLES = {
    projectTitle: "",
    biteTitle: "",
    screenTitle: ""
};

//USER DATA MODELS

export let USER_DATA_MODEL = {
    status: "",
    percentageComplete: 0,
    bites: []
};



export let USER_DATA_BITE = {
    bite_id: "",
    screens: [],
    kpis: [],
    status: "",
    percentageComplete: 0,
};


export let USER_DATA_BADGE = {
    badge_id: 0,
    achieved: 0,
    achievedOn: []
};

export let USER_DATA_BITE_KPI = {
    kpi_id: 0,
    is_primary: false,
    min: 0,
    max: 0,
    start: 0,
    current: 0,
    yellow: 0,
    green: 0,
    style: "",
    unit_type: "",
    is_visible: false,
    positive_type: "",
    decimals_points: 0,
    totalPoints: 0,
    currentScoreRange: "",
    last: 0,
    value: 0,
    history: []
};

export let USER_DATA_SCREEN = {
    screen_id: "",
    objects: [],
    status: ""
};

export let USER_DATA_SCREEN_OBJECT = {
    object_id: "",
    asset_type_code: "",
    status: ""
};

export const ALLOWED_IMAGE_FILES = [

    "gif",
    "jpg",
    "jpeg",
    "svg",
    "png",
];


export const ALLOWED_AUDIO_FILES = [
    "mp3"
];

export let FONT_SIZE = {
    currentFontSize: 100,
    maxFontSize: 200,
    minFontSize: 75,
    resetFontSize: 100
};

export let RESOURCE_PROPS = {
	sourceId: "",
	activeResourcesId: 0,
};


/** WEBPACK FOOTER **
 ** ./src/models/appModels.js
 **/